import { GlobalFilter } from "projects/shared/src/models/global/GlobalFilter";

export class MonitorTaskProductListDataFilter extends GlobalFilter {
  taskId!: number;
}
